import axios from "axios";
import { environment } from "../../../environment";
const url = (accountId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/external-account/v1/funding-accounts/${accountId}/activate`
        : `https://middleware.uat.farther.com/external-account/v1/funding-accounts/${accountId}/activate`;
};
export default async function setFundingAccount(accountId, attachment, config) {
    await axios.put(url(accountId), createRequestBody(attachment), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...(attachment !== null && { "Content-Type": "multipart/form-data" }),
        },
    });
}
const createRequestBody = (attachment) => {
    if (attachment === null) {
        return {};
    }
    const formData = new FormData();
    formData.append("attachment", attachment);
    return formData;
};
//# sourceMappingURL=setFundingAccount.js.map